<template>
  <div :class="containerClass">
    <a v-if="innerLink && !blocked" :href="innerLink" :class="linkClass" target="_blank" rel="noopener">
      <img src="/whatsapp.svg" width="30px" height="30px">
    </a>
    <span
      v-else
      :class="linkClass"
      class="whatsapp-link-disabled"
      :title="blocked ? blockedMessage : invalidPhoneMessage"
      role="button"
      aria-disabled="true"
      @click="notifyInvalidPhone"
    >
      <img src="/whatsapp.svg" width="30px" height="30px">
    </span>
  </div>
</template>
<script>
import { normalizeIsraeliPhoneForWhatsApp, WHATSAPP_INVALID_PHONE_MESSAGE } from '@/custom/classes/my_utils.js'
import { BLOCKED_TOAST } from '@/custom/helpers/applicant_block.js'

export default {
  name: 'whatsapp-link',
  props: {
    phoneNumber: {
      type: [String, Number],
      default: ''
    },
    message: {
      type: String,
      default: ' '
    },
    containerClass: {
      type: String,
      default: ''
    },
    linkClass: {
      type: String,
      default: ''
    },
    // Blocked candidate (v2): render the disabled icon, never a wa.me link.
    blocked: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      invalidPhoneMessage: WHATSAPP_INVALID_PHONE_MESSAGE,
      blockedMessage: BLOCKED_TOAST
    }
  },
  computed: {
    innerPhoneNumber () {
      return normalizeIsraeliPhoneForWhatsApp(this.phoneNumber) || undefined
    },
    innerLink () {
      if (!this.innerPhoneNumber) return ''
      return 'https://api.whatsapp.com/send?phone=' + encodeURIComponent(this.innerPhoneNumber) + '&text=' + encodeURIComponent(this.message)
    }
  },
  methods: {
    notifyInvalidPhone () {
      if (this.$utils && this.$utils.emit) {
        this.$utils.emit('show_toast', { text: this.blocked ? BLOCKED_TOAST : WHATSAPP_INVALID_PHONE_MESSAGE })
      }
    }
  }
}
</script>
<style scoped>
.whatsapp-link-disabled {
  display: inline-block;
  cursor: not-allowed;
  opacity: 0.4;
  filter: grayscale(100%);
}
</style>
